import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import about from '../../images/blog/about-widget.jpg';
import { useFetch } from '../../hooks/useFetch';
import { fetchprojects } from '../../api/api';

const BlogSidebar = ({ categories, tags }) => {
    const { t } = useTranslation();
    const { data: projects, isLoading, error } = useFetch(["projects"], fetchprojects);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className={`col col-lg-4 col-12 `}>
            <div className="blog-sidebar">

                <div className="widget category-widget">
                    <h3>{t('blogSidebar.categories.title')}</h3>
                    <ul>
                        {categories.slice(0, 6).map((category, Sitem) => (
                            <li key={Sitem}>
                                <Link onClick={ClickHandler} to={`/blog?category=${category}`}>
                                    {category} <span>{Sitem + 1}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="widget wpo-instagram-widget">
                    <div className="widget-title">
                        <h3>{t('blogSidebar.projects.title')}</h3>
                    </div>
                    <ul className="d-flex">
                        {projects?.data?.data.slice(0, 6).map((project, pitem) => (
                            <li className="grid" key={pitem}>
                                <div className="img-holder">
                                    <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>
                                        <img
                                            src={`${process.env.REACT_APP_API_URL}/api/images/${project?.data?.thumbnail}`}
                                            alt=""
                                        />
                                    </Link>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="widget tag-widget">
                    <h3>{t('blogSidebar.tags.title')}</h3>
                    <ul>
                        {tags.slice(0, 6).map((tag, Titem) => (
                            <li key={Titem}>
                                <Link onClick={ClickHandler} to={`/blog?tag=${tag}`}>
                                    {tag}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="wpo-contact-widget widget">
                    <h2>{t('blogSidebar.contact.title')}</h2>
                    <p>{t('blogSidebar.contact.description')}</p>
                    <Link onClick={ClickHandler} to="/contact">
                        {t('blogSidebar.contact.button')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default BlogSidebar;
